import { Injectable } from "@angular/core";
import { HubConnection, HubConnectionBuilder } from "@aspnet/signalr";
import { environment } from "src/environments/environment";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { UserDetailsService } from "../../Components/Services/user-details.service";
import { ISystemNotification } from "src/app/Models/Interface/SystemNotification/system-notification";
import { Observable } from "rxjs";
import { DataService } from "../DataService/data.service";
import { IBaseData } from "src/app/Models/Interface/Base/base-data";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";

@Injectable({
  providedIn: "root",
})
export class SystemNotificationService {
  endPoint = environment.realTimeEndPoint;
  signalData = {
    data: [],
    count: 0,
  } as IBaseDataList<ISystemNotification[]>;
  public _hubConnection: HubConnection;

  constructor(
    private userDetailsService: UserDetailsService,
    private dataService: DataService
  ) {
    this._hubConnection = new HubConnectionBuilder()
      .withUrl(this.endPoint + APIName.systemNotification.list)
      .build();
  }

  onReadNotify(id: number): Observable<IBaseData<any>> {
    return this.dataService.post(APIName.systemNotification.markNotify, { id });
  }

  terminateConnection() {
    this.signalData = {
      data: [],
      count: 0,
    };
    this._hubConnection.stop();
  }
}
